import React from 'react';
import { RegisterForm } from '../components/auth/RegisterForm';
import { Layout } from '../components/common/Layout';
import { Link } from 'react-router-dom';

const Register: React.FC = () => {
  return (
    <Layout>
      <div className="mb-4 flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold">Create Account</h1>
        <Link
          to="/"
          className="inline-flex items-center rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-1.5 text-xs font-medium text-slate-700 dark:text-slate-300 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Go home
        </Link>
      </div>
      <RegisterForm />
    </Layout>
  );
};

export default Register;
